module.exports = __webpack_public_path__ + "img/ppmi_logo.ed7b2c2e.jpg";